import { useSearchParams, Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancelPage() {
  const [params] = useSearchParams();
  const tenantId = params.get("tenant_id");

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="max-w-md w-full bg-card border border-border rounded-xl shadow-lg p-8 text-center" data-testid="payment-cancel-card">
        <div className="w-16 h-16 rounded-full bg-amber-500/10 flex items-center justify-center mx-auto">
          <XCircle className="w-10 h-10 text-amber-600" />
        </div>
        <h1 className="font-display text-2xl font-bold mt-4">Checkout cancelled</h1>
        <p className="text-sm text-muted-foreground mt-2">
          Your account was not activated — no charge was made. Your info is saved, so you can pick up right where you left off.
        </p>
        {tenantId && (
          <p className="text-xs text-muted-foreground mt-3 font-mono">Tenant reference: {tenantId}</p>
        )}
        <div className="flex flex-col gap-2 mt-6">
          <Link to="/signup">
            <Button className="w-full group" data-testid="payment-cancel-retry-btn">
              Try again <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-0.5 transition-transform" />
            </Button>
          </Link>
          <Link to="/login" className="text-xs text-muted-foreground underline">Already have an account? Sign in</Link>
        </div>
      </div>
    </div>
  );
}
